import { createRouter, createWebHistory } from 'vue-router'
import store from '@/store'

const routes = [
  {
    path: '/',
    name: 'Início',
    component: () => import('@/views/SubjectsView.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/home',
    name: 'Home',
    component: () => import('@/views/SubjectsView.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/auth',
    name: 'Autenticação',
    component: () => import('@/views/LoginView.vue'),
    meta: { requiresAuth: false, hideHeader: true }
  },
  {
    path: '/register',
    name: 'Cadastro',
    component: () => import('@/views/RegisterView.vue'),
    meta: { requiresAuth: false }
  },
  {
    path: '/confirm-account/:token',
    name: 'Confirm Account',
    component: () => import('@/views/ConfirmAcountView.vue'),
    meta: { requiresAuth: false, hideHeader: false, hideSidebar: true }
  },
  {
    path: '/profile/account',
    name: 'Perfil',
    component: () => import('@/views/ProfileView.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/notification',
    name: 'Notificação',
    component: () => import('@/views/NotificationView.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/subjects',
    name: 'Disciplinas',
    component: () => import('@/views/SubjectsView.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/progress',
    name: 'Meu Progresso',
    component: () => import('@/views/ProgressView.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/subject/:id_subject',
    name: 'Disciplina',
    component: () => import('@/views/SubjectView.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/aula/:idaula',
    name: 'Aula',
    component: () => import('@/views/AulaView.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/avaliacoes',
    name: 'Avaliações',
    component: () => import('@/views/AvaliacoesView.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/documentos',
    name: 'Documentos',
    component: () => import('@/views/DocumentosView.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/certificados',
    name: 'Certificados',
    component: () => import('@/views/CertificadosView.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/password-reset/:tokenPass?',
    name: 'Redefinir Senha',
    component: () => import('@/views/PasswordResetView.vue'),
    meta: { requiresAuth: false }
  },
  {
    path: '/faq',
    name: 'F.A.Q',
    component: () => import('@/views/FaqView.vue'),
    meta: { requiresAuth: false }
  },
  {
    path: '/coordinators',
    name: 'Coordenadores',
    component: () => import('@/views/CoordinatorsView.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/calendario',
    name: 'Calendário',
    component: () => import('@/views/CalendarView.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/error',
    name: 'Error 404',
    component: () => import('@/views/Error404.vue'),
    meta: { requiresAuth: false, hideSidebar: true }
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: '/error'
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else if (to.hash) {
    
      return {
        el: to.hash,
        behavior: 'smooth',
        top: 100
      }
    } else {
      return { x: 0, y: 0 };
    }
  },
})

router.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth)
  const isAuthenticated = !!store.state.user.user

  if (requiresAuth && !isAuthenticated) {
    store.commit('SET_REDIRECT', to.path)
    store.commit('LOG_USER_OUT')
    next({ name: 'Autenticação' })
  } else {
    document.title = `${to.name} | ${process.env.VUE_APP_TITLE}`
    window.scrollTo(0, 0)
    next()
  }
})
export default router
